import { render, staticRenderFns } from "./LayoutReport.vue?vue&type=template&id=ecd50fda"
import script from "./LayoutReport.vue?vue&type=script&lang=ts"
export * from "./LayoutReport.vue?vue&type=script&lang=ts"
import style0 from "./LayoutReport.vue?vue&type=style&index=0&id=ecd50fda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
